import { render, staticRenderFns } from "./WindowStackView.vue?vue&type=template&id=d196ed78&scoped=true&"
import script from "./WindowStackView.vue?vue&type=script&lang=js&"
export * from "./WindowStackView.vue?vue&type=script&lang=js&"
import style0 from "./WindowStackView.vue?vue&type=style&index=0&id=d196ed78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196ed78",
  null
  
)

export default component.exports